import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { getNativeContext } from '../helpers/get-native-context';
import { setInternalState } from '../helpers/set-internal-state';
import { wrapEventListener } from '../helpers/wrap-event-listener'; // The DEFAULT_OPTIONS are only of type Partial<IOscillatorOptions> because there is no default value for periodicWave.

var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  detune: 0,
  frequency: 440,
  type: 'sine'
};
export var createOscillatorNodeConstructor = function createOscillatorNodeConstructor(createAudioParam, createInvalidStateError, createNativeOscillatorNode, createOscillatorNodeRenderer, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(OscillatorNode, _noneAudioDestination);

      function OscillatorNode(context) {
        var _this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

        _classCallCheck(this, OscillatorNode);

        var nativeContext = getNativeContext(context);

        var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);

        var nativeOscillatorNode = createNativeOscillatorNode(nativeContext, mergedOptions);
        var isOffline = isNativeOfflineAudioContext(nativeContext);
        var oscillatorNodeRenderer = isOffline ? createOscillatorNodeRenderer() : null;
        var nyquist = context.sampleRate / 2;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(OscillatorNode).call(this, context, 'passive', nativeOscillatorNode, oscillatorNodeRenderer)); // Bug #81: Edge, Firefox & Safari do not export the correct values for maxValue and minValue.

        _this._detune = createAudioParam(_assertThisInitialized(_this), isOffline, nativeOscillatorNode.detune, 153600, -153600); // Bug #76: Edge & Safari do not export the correct values for maxValue and minValue.

        _this._frequency = createAudioParam(_assertThisInitialized(_this), isOffline, nativeOscillatorNode.frequency, nyquist, -nyquist);
        _this._nativeOscillatorNode = nativeOscillatorNode;
        _this._onended = null;
        _this._oscillatorNodeRenderer = oscillatorNodeRenderer;

        if (_this._oscillatorNodeRenderer !== null && mergedOptions.periodicWave !== undefined) {
          _this._oscillatorNodeRenderer.periodicWave = mergedOptions.periodicWave;
        }

        return _this;
      }

      _createClass(OscillatorNode, [{
        key: "setPeriodicWave",
        value: function setPeriodicWave(periodicWave) {
          this._nativeOscillatorNode.setPeriodicWave(periodicWave);

          if (this._oscillatorNodeRenderer !== null) {
            this._oscillatorNodeRenderer.periodicWave = periodicWave;
          }
        }
      }, {
        key: "start",
        value: function start() {
          var _this2 = this;

          var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          this._nativeOscillatorNode.start(when);

          if (this._oscillatorNodeRenderer !== null) {
            this._oscillatorNodeRenderer.start = when;
          } else {
            setInternalState(this, 'active');

            var setInternalStateToInactive = function setInternalStateToInactive() {
              _this2._nativeOscillatorNode.removeEventListener('ended', setInternalStateToInactive); // @todo Determine a meaningful delay instead of just using one second.


              setTimeout(function () {
                return setInternalState(_this2, 'passive');
              }, 1000);
            };

            this._nativeOscillatorNode.addEventListener('ended', setInternalStateToInactive);
          }
        }
      }, {
        key: "stop",
        value: function stop() {
          var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          this._nativeOscillatorNode.stop(when);

          if (this._oscillatorNodeRenderer !== null) {
            this._oscillatorNodeRenderer.stop = when;
          }
        }
      }, {
        key: "detune",
        get: function get() {
          return this._detune;
        }
      }, {
        key: "frequency",
        get: function get() {
          return this._frequency;
        }
      }, {
        key: "onended",
        get: function get() {
          return this._onended;
        },
        set: function set(value) {
          var wrappedListener = wrapEventListener(this, value);
          this._nativeOscillatorNode.onended = wrappedListener;
          var nativeOnEnded = this._nativeOscillatorNode.onended;
          this._onended = nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
      }, {
        key: "type",
        get: function get() {
          return this._nativeOscillatorNode.type;
        },
        set: function set(value) {
          this._nativeOscillatorNode.type = value; // Bug #57: Edge will not throw an error when assigning the type to 'custom'. But it still will change the value.

          if (value === 'custom') {
            throw createInvalidStateError();
          }

          if (this._oscillatorNodeRenderer !== null) {
            this._oscillatorNodeRenderer.periodicWave = null;
          }
        }
      }]);

      return OscillatorNode;
    }(noneAudioDestinationNodeConstructor)
  );
};